import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Courts from "@/pages/Courts";
import CourtDetail from "@/pages/CourtDetail";
import Coaching from "@/pages/Coaching";
import Membership from "@/pages/Membership";
import Assistant from "@/pages/Assistant";
import Admin from "@/pages/Admin";
import BookingLookup from "@/pages/BookingLookup";
import MemberWall from "@/pages/MemberWall";
import AuthCallback from "@/components/AuthCallback";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Layout() {
  const { pathname, hash } = useLocation();
  const isAssistant = pathname === "/assistant";
  if (hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/courts" element={<Courts />} />
        <Route path="/courts/:courtId" element={<CourtDetail />} />
        <Route path="/coaching" element={<Coaching />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/assistant" element={<Assistant />} />
        <Route path="/my-booking" element={<BookingLookup />} />
        <Route path="/members" element={<MemberWall />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAssistant && <Footer />}
      {!isAssistant && <ChatWidget />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
